<div class="dot-slider-wrapper position-relative w-100">
  @if(isIImage) {
  <img
    class="image position-relative img-fluid rounded w-100"
    alt="slide"
    [src]="image.key | signedUrl : image.path | async"
  />} @else{
  <img class="image img-fluid rounded d-block" alt="slide" [src]="src" />
  } @if(finalDots > 1) {
  <div
    class="d-flex justify-content-center gap-1 position-absolute mb-2 bottom-0 start-50 translate-middle-x"
  >
    @for (dot of dotsRange; track $index) {
    <div
      class="dot cursor rounded-circle"
      [ngClass]="{
        'bg-primary': curIndex === dot,
        'bg-secondary': curIndex !== dot
      }"
      (click)="setImageByDot(dot)"
    ></div>
    }
  </div>
  }
</div>
